
export function AktenSidebarAssistantsButton() {
    return null
}